import { Goal, NewGoalWithID } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export const getSubGoalLevel = (
  id: ID | undefined,
  goals: (Goal | NewGoalWithID)[],
): number => {
  if (!id) {
    return 0;
  }

  const calculateLevel = (currentId: ID, visitedIds: Set<ID>): number => {
    const goal = goals.find((g) => g.id === currentId);

    if (!goal || !goal.parentIds?.length || visitedIds.has(currentId)) {
      return 0;
    }

    visitedIds.add(currentId);

    const parentId = goal.parentIds[goal.parentIds.length - 1];

    // if there is no parent, then the goal is at the current level
    const parentGoalExists = goals.some((g) => g.id === parentId);
    if (!parentGoalExists) {
      return 0;
    }

    return 1 + calculateLevel(parentId, visitedIds);
  };

  return calculateLevel(id, new Set());
};
